import config from "config/config";
import { getToken } from "js/formatting/getToken";
export async function getPaymentProfileApi(payload) {
  let options = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `bearer ${getToken()}`,
    },
  };

  let paymentProfilequeryString = "";
  if (payload?.policies?.length > 0) {
    payload?.policies.forEach((policy, index) => {
      if (policy?.creditCard?.recurringReferenceId) {
        paymentProfilequeryString = `${paymentProfilequeryString}ProfileIds[${index}].paymentProfileId=${policy?.creditCard?.recurringReferenceId}&`;
        if (payload?.policies?.length - 1 !== index)
          paymentProfilequeryString = `${paymentProfilequeryString}ProfileIds[${index}].blockCode=${policy?.blockCode}&`;
        else
          paymentProfilequeryString = `${paymentProfilequeryString}ProfileIds[${index}].blockCode=${policy?.blockCode}`;
      }
    });
  }
  let queryString = "";
  if (payload?.UserId) {
    queryString = `userId=${payload.UserId}`;
  }
  if (paymentProfilequeryString !== "") {
    queryString = queryString + "&" + paymentProfilequeryString;
  }

  const response = await fetch(
    config.REG_API_BASE_URL + "/Payment/Profile?" + queryString,
    options
  );

  if (!response.ok) {
    throw await response.json();
  } else {
    if (response.status === 204) {
      return null;
    } else {
      const data = await response.json();
      return data;
    }
  }
}
